'use client';

import { useEffect } from 'react';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import Bugsnag from '@bugsnag/js';
import { Button, Box, Typography } from '@/lib/mui';

const PRODUCTION = 'production';
const API_KEY = '86e3178326f6b19ab596d089850a894e';
const DEBUG = process && process.env.NODE_ENV !== 'production';

if (!DEBUG) {
  Bugsnag.start({
    apiKey: API_KEY,
    plugins: [new BugsnagPluginReact()],
    releaseStage: PRODUCTION,
    enabledReleaseStages: [PRODUCTION],
    collectUserIp: false,
    autoDetectErrors: false,
  });
}

export default function Error({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  useEffect(() => {
    if (!DEBUG) {
      Bugsnag.notify(error);
    }
  }, [error]);

  return (
    <Box
      sx={{
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'column',
        padding: '0 2rem',
        height: '100%',
      }}
    >
      <Typography mt={5} variant="h5">
        Something went wrong!
      </Typography>
      <Typography mt={2}>
        There was an error. Please try again later.
      </Typography>
      <Box mt={5} mb={5}>
        <Button variant="contained" color="secondary" onClick={() => reset()}>
          Try Again
        </Button>
      </Box>
    </Box>
  );
}
